export default __webpack_public_path__ + "1d9e6d07c9eb65f61a3b2e4c70be9b8d.png";